import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, unref as _unref, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/png/quizz-illustration.png'


const _withScopeId = n => (_pushScopeId("data-v-00fff6e3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "quizz-illustration row" }
const _hoisted_2 = { class: "illustration col-lg-7 col-12" }
const _hoisted_3 = {
  key: 0,
  class: "text-lg d-block d-sm-block d-md-block d-lg-none"
}
const _hoisted_4 = { class: "illustration-box" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "quizz-illustration"
}, null, -1))
const _hoisted_6 = { class: "right-side col-lg-5 col-12" }
const _hoisted_7 = {
  key: 0,
  class: "d-none d-sm-none d-md-none d-lg-block"
}
const _hoisted_8 = { class: "text-lg" }
const _hoisted_9 = { class: "answers" }
const _hoisted_10 = { class: "btn-submit" }
const _hoisted_11 = ["disabled"]

import Justification from './QuizzJustification.vue'
import {
  QuizzJustification,
  QuizzSentence,
  QuizzType,
  QuizzIllustrationUserAnswer,
} from '@/types/Quizz'
import QuizzIllustrationPlaceholder from './Illustration/QuizzIllustrationPlaceholder.vue'
import QuizzIllustrationAnswer from './Illustration/QuizzIllustrationAnswer.vue'
import QuizzIllustrationMobileModal from './Illustration/QuizzIllustrationMobileModal.vue'
import { computed, onMounted, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
    currentAnswersId: null,
    sentence: null,
    justification: null,
    disabledSubmitBtn: { type: Boolean },
    showJustification: { type: Boolean }
  },
  emits: ['onSubmit', 'update:currentAnswersId'],
  setup(__props: any, { emit }) {

const props = __props as {
  currentAnswersId: number[] // v-model
  sentence: QuizzSentence
  justification: QuizzJustification
  disabledSubmitBtn: boolean
  showJustification: boolean
}





const currentUserAnswers = ref<QuizzIllustrationUserAnswer[]>([])

const quizzIllustrationMobileModal = ref<InstanceType<
  typeof QuizzIllustrationMobileModal
> | null>(null)

onMounted(() => {
  loadUserAnswers()
})

const currentAnswersId = computed({
  get() {
    return props.currentAnswersId
  },
  set(value) {
    emit('update:currentAnswersId', value)
  },
})

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function onDragOver(ev: any) {
  ev.preventDefault()
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function onDrop(ev: any) {
  ev.preventDefault()

  var sourceAnswerId = parseInt(ev.dataTransfer.getData('text/plain') ?? 0)

  let target = ev.target

  if (target.classList.value.includes('quizz-illustration-card')) {
    target = target.parentElement
  }

  const targetAnswerId = parseInt(target.id.split('-').pop())

  console.log(`[OnDrop] Dropping ${sourceAnswerId} on ${targetAnswerId}`)

  saveUserAnswers(targetAnswerId, sourceAnswerId)
}

function loadUserAnswers() {
  currentUserAnswers.value.length = 0

  currentAnswersId.value.forEach((answerId, index) => {
    currentUserAnswers.value.push({
      targetId: index + 1,
      answerId,
    })
  })
}

function onMobileModalOpen(targetId: number) {
  quizzIllustrationMobileModal.value?.show(targetId)
}

function onModalCardClick(targetId: number, answerId: number) {
  saveUserAnswers(targetId, answerId)
}

function saveUserAnswers(targetId: number, answerId: number) {
  // Remove existing answer
  const existingAnswerIdIndex = currentUserAnswers.value.findIndex(
    (userAnswer) => userAnswer.answerId === answerId
  )
  if (existingAnswerIdIndex !== -1) {
    currentUserAnswers.value.splice(existingAnswerIdIndex, 1)
  }

  if (Number.isNaN(targetId)) {
    return
  }

  const existingTargetIdIndex = currentUserAnswers.value.findIndex(
    (userAnswer) => userAnswer.targetId === targetId
  )
  if (existingTargetIdIndex !== -1) {
    currentUserAnswers.value[existingTargetIdIndex].answerId = answerId
  } else {
    currentUserAnswers.value.push({
      targetId,
      answerId,
    })
  }

  const currentUserAnswersSorted = currentUserAnswers.value.sort(function (
    a,
    b
  ) {
    return -(b.targetId - a.targetId)
  })

  const newAnswersIds: number[] = []

  currentUserAnswersSorted.forEach((userAnswer) => {
    newAnswersIds.push(userAnswer.answerId)
  })

  currentAnswersId.value = newAnswersIds
}

function currentAnswerForId(id: number) {
  const index = currentUserAnswers.value.findIndex(
    (userAnswer) => userAnswer.targetId === id
  )

  return index !== -1 ? currentUserAnswers.value[index].answerId : null
}

function isAnswerUsedForId(id: number) {
  const index = currentUserAnswers.value.findIndex(
    (userAnswer) => userAnswer.answerId === id
  )

  return index !== -1
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!props.showJustification)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.$t('quizz.mobileClicking')), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.sentence.answers.length, (index) => {
          return (_openBlock(), _createBlock(QuizzIllustrationPlaceholder, {
            key: index,
            id: index,
            "current-answer-id": currentAnswerForId(index),
            sentence: props.sentence,
            showFeedback: props.showJustification,
            onOnDrop: onDrop,
            onOnDragOver: onDragOver,
            onOnClick: onMobileModalOpen
          }, null, 8, ["id", "current-answer-id", "sentence", "showFeedback"]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (!props.showJustification)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('quizz.dragAndDrop')), 1),
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.sentence.answers, (answer) => {
                return (_openBlock(), _createBlock(QuizzIllustrationAnswer, {
                  key: answer.id,
                  answer: answer,
                  "is-used": isAnswerUsedForId(answer.id),
                  onOnDrop: onDrop,
                  onOnDragOver: onDragOver
                }, null, 8, ["answer", "is-used"]))
              }), 128))
            ])
          ]))
        : (_openBlock(), _createBlock(Justification, {
            key: 1,
            class: "justification",
            "quizz-type": _unref(QuizzType).ILLUSTRATION,
            justification: props.justification
          }, null, 8, ["quizz-type", "justification"])),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("button", {
          disabled: props.disabledSubmitBtn,
          class: "btn btn-md btn-primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('onSubmit')))
        }, [
          _createElementVNode("span", null, _toDisplayString(props.showJustification
              ? _ctx.$t('quizz.next')
              : _ctx.$t('quizz.submitMyChoice')), 1)
        ], 8, _hoisted_11)
      ])
    ]),
    _createVNode(QuizzIllustrationMobileModal, {
      ref_key: "quizzIllustrationMobileModal",
      ref: quizzIllustrationMobileModal,
      "current-user-answers": currentUserAnswers.value,
      sentence: props.sentence,
      onOnCardClick: onModalCardClick
    }, null, 8, ["current-user-answers", "sentence"])
  ]))
}
}

})